import { render } from "./RoleDetailEdit.vue?vue&type=template&id=fc10037c&scoped=true"
import script from "./RoleDetailEdit.vue?vue&type=script&lang=js"
export * from "./RoleDetailEdit.vue?vue&type=script&lang=js"

import "./RoleDetailEdit.vue?vue&type=style&index=0&id=fc10037c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc10037c"]])

export default __exports__